import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [kategorien, setKategorien] = useState([]);
  const [loadingKategorien, setLoadingKategorien] = useState(true);
  const [errorKategorien, setErrorKategorien] = useState(null);

  const KATEGORIEN_API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Kategorien?fields=*.*&sort=sort&limit=1500&filter[status][_eq]=published';

  useEffect(() => {
    const ac = new AbortController();
    const fetchKategorien = async () => {
      setLoadingKategorien(true); setErrorKategorien(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(KATEGORIEN_API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setKategorien(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setErrorKategorien('Error');
      } finally {
        if (!ac.signal.aborted) setLoadingKategorien(false);
      }
    };
    fetchKategorien();
    /* return () => ac.abort(); */
  }, []);

  return (
    <CategoryContext.Provider value={{ kategorien, loadingKategorien, errorKategorien }}>
      {children}
    </CategoryContext.Provider>
  );
};
